// Editorial narrative content for each project's case-study page (FR / EN).
// Photos & cover come from galleryData.js (matched by project key).

export const caseStudyContent = {
  villa: {
    fr: {
      tagline: "La lumière comme matière première.",
      context:
        "Une résidence privée pensée autour d'une seule obsession : capter la lumière naturelle et la laisser sculpter l'espace, heure après heure.",
      vision:
        "Créer des volumes épurés et intemporels où chaque circulation, de la façade aux pièces de vie, respire et se prolonge dans la clarté.",
      approach:
        "Nous avons travaillé les proportions, les lignes de fuite et les ouvertures pour que la lumière devienne l'ornement principal — sans surcharge, sans artifice. Chaque matière a été choisie pour dialoguer avec le jour.",
      materials: ["Tons ivoire & taupe", "Bois clair", "Surfaces mates", "Lignes minimalistes"],
      result:
        "Un intérieur serein et lumineux, d'une élégance sans effort, qui évolue avec le jour et ne se démode pas.",
    },
    en: {
      tagline: "Light as the primary material.",
      context:
        "A private residence built around a single obsession: to capture natural light and let it sculpt the space, hour after hour.",
      vision:
        "To create pure, timeless volumes where every circulation, from the façade to the living areas, breathes and extends into clarity.",
      approach:
        "We worked the proportions, sightlines and openings so that light itself became the main ornament — no clutter, no artifice. Every material was chosen to converse with daylight.",
      materials: ["Ivory & taupe tones", "Pale wood", "Matte surfaces", "Minimalist lines"],
      result:
        "A serene, luminous interior of effortless elegance that shifts with the day and never dates.",
    },
  },
  albert: {
    fr: {
      tagline: "Du gros œuvre au dernier détail.",
      context:
        "Un espace sous combles à réinventer entièrement — du croquis initial au chantier, jusqu'à l'aménagement final.",
      vision:
        "Transformer des combles contraints en un intérieur chaleureux, contemporain et parfaitement fonctionnel.",
      approach:
        "Une maîtrise d'œuvre globale : démolition, structure, agencement sur mesure et mise en lumière, orchestrés dans une même cohérence. Rien n'a été laissé au hasard, du premier trait au dernier réglage.",
      materials: ["Bois chaleureux", "Menuiseries sur mesure", "Lumière indirecte", "Volumes optimisés"],
      result:
        "Un lieu de vie contemporain et accueillant, né d'une transformation complète menée de bout en bout.",
    },
    en: {
      tagline: "From structural work to the final detail.",
      context:
        "A loft space to be entirely reinvented — from the initial sketch to the building site and the final fit-out.",
      vision:
        "To transform constrained loft space into a warm, contemporary and perfectly functional interior.",
      approach:
        "End-to-end project management: demolition, structure, bespoke joinery and lighting design, orchestrated with a single coherence. Nothing was left to chance, from the first line to the last adjustment.",
      materials: ["Warm wood", "Bespoke joinery", "Indirect light", "Optimised volumes"],
      result:
        "A contemporary, welcoming living space born from a complete, end-to-end transformation.",
    },
  },
  deuxpm: {
    fr: {
      tagline: "Une identité, du concept à la réalisation.",
      context:
        "Un projet global où tout — de la façade aux moindres détails intérieurs — devait raconter une même histoire.",
      vision:
        "Orchestrer une identité cohérente et raffinée, portée par la lumière et les matières nobles.",
      approach:
        "Jeux de lumière indirecte, sélection de matières d'exception et détails maîtrisés, pensés comme un tout indissociable. La cohérence a guidé chaque décision.",
      materials: ["Matières nobles", "Lumière indirecte", "Détails maîtrisés", "Cohérence globale"],
      result:
        "Un ensemble d'une sophistication rare, cohérent du premier au dernier geste.",
    },
    en: {
      tagline: "One identity, from concept to completion.",
      context:
        "A comprehensive project where everything — from the façade to the smallest interior detail — had to tell one story.",
      vision:
        "To orchestrate a coherent, refined identity, carried by light and noble materials.",
      approach:
        "Plays of indirect light, a selection of exceptional materials and mastered details, conceived as an inseparable whole. Coherence guided every decision.",
      materials: ["Noble materials", "Indirect light", "Mastered details", "Global coherence"],
      result:
        "An ensemble of rare sophistication, coherent from the first gesture to the last.",
    },
  },
};
